export type AccessTier = 'floor_layout' | 'full_package';

export type FunnelAnalyticsData = {
  design_number: number;
  access_tier: AccessTier;
};

export type AnalyticsTracker = {
  track(name: string, data: FunnelAnalyticsData): void;
};

export const PAYMENT_RETURN_EVENTS = {
  completed: 'payment_return_completed',
  cancelled: 'payment_return_cancelled',
  failed: 'payment_return_failed',
  pending: 'payment_return_pending',
} as const;

function payload(designNumber: string | number, accessTier: AccessTier): FunnelAnalyticsData {
  return {
    design_number: Number(designNumber),
    access_tier: accessTier,
  };
}

export function trackFunnelEvent(
  tracker: AnalyticsTracker | undefined,
  name: string,
  designNumber: string | number,
  accessTier: AccessTier,
): boolean {
  if (!tracker) return false;

  try {
    tracker.track(name, payload(designNumber, accessTier));
    return true;
  } catch {
    return false;
  }
}

export function trackPrivateAccessOpened(
  tracker: AnalyticsTracker | undefined,
  designNumber: string | number,
): void {
  trackFunnelEvent(tracker, 'private_access_opened', designNumber, 'floor_layout');
  trackFunnelEvent(tracker, 'access_tier_selected', designNumber, 'floor_layout');
}

export function trackAccessTierSelected(
  tracker: AnalyticsTracker | undefined,
  designNumber: string | number,
  accessTier: AccessTier,
): void {
  trackFunnelEvent(tracker, 'access_tier_selected', designNumber, accessTier);
}

export function trackCheckoutCreated(
  tracker: AnalyticsTracker | undefined,
  designNumber: string | number,
  accessTier: AccessTier,
): void {
  trackFunnelEvent(tracker, 'checkout_created', designNumber, accessTier);
}

export function paymentReturnEvent(status: string): typeof PAYMENT_RETURN_EVENTS[keyof typeof PAYMENT_RETURN_EVENTS] {
  if (status === 'completed' || status === 'cancelled' || status === 'failed') {
    return PAYMENT_RETURN_EVENTS[status];
  }
  return PAYMENT_RETURN_EVENTS.pending;
}

export function trackPaymentReturn(
  tracker: AnalyticsTracker | undefined,
  status: string,
  designNumber: string | number,
  accessTier: AccessTier,
): boolean {
  return trackFunnelEvent(tracker, paymentReturnEvent(status), designNumber, accessTier);
}